import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  MdAddShoppingCart,
  MdPerson,
  MdAssignmentTurnedIn,
  MdToc,
  MdCreate,
  MdExtension,
  MdPageview,
  MdInsertDriveFile,
  MdKeyboardArrowDown,
  MdDashboard,
  MdShoppingCart,
  MdExitToApp,
} from 'react-icons/md';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

import { GiFactory } from 'react-icons/gi';
import { AiFillTag, AiFillTags, AiFillSignal } from 'react-icons/ai';
import { BsReverseLayoutTextWindowReverse } from 'react-icons/bs';
import {
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from 'utils/bemnames';
import { Divider } from '@material-ui/core';
import logo200Image from 'assets/img/logo/logo_200.png';
import sidebarBgImage from 'assets/img/sidebar/sidebar-4.jpg';
import logoqa from '../../assets/img/sidebar/logo.jpg';
import { RiDashboardLine } from 'react-icons/ri';
import { RiHomeOfficeLine } from 'react-icons/ri';
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import { MdOutlineAddBusiness } from 'react-icons/md';
import { MdAddBusiness } from 'react-icons/md';
import { TiGroupOutline } from 'react-icons/ti';
import { SiCodeclimate } from 'react-icons/si';
import { TbRulerMeasure } from 'react-icons/tb';
import StraightenIcon from '@mui/icons-material/Straighten';
import { MdOutlineLinearScale } from 'react-icons/md';
import { IoColorPaletteOutline } from 'react-icons/io5';
import { GiRolledCloth } from 'react-icons/gi';
import { PiOfficeChairLight } from 'react-icons/pi';
import { GiClothes } from 'react-icons/gi';
import { AiOutlineDeploymentUnit } from 'react-icons/ai';
import { TbCoinTaka } from 'react-icons/tb';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { TbWorldPlus } from 'react-icons/tb';
import { VscGroupByRefType } from 'react-icons/vsc';
import { VscTypeHierarchySub } from 'react-icons/vsc';
import { MdOutlineSettingsInputComposite } from 'react-icons/md';
import { FaUserCog } from 'react-icons/fa';
import { AiOutlineAudit } from 'react-icons/ai';
import { MdShoppingCartCheckout } from 'react-icons/md';
import { MdOutlineShoppingBag } from 'react-icons/md';
import { PiCheckSquareOffsetFill } from 'react-icons/pi';
import { BiMessageSquareEdit } from 'react-icons/bi';
import { VscOpenPreview } from 'react-icons/vsc';
import { BsUiChecks } from 'react-icons/bs';
import { BiSpreadsheet } from 'react-icons/bi';
import { BiTransferAlt } from 'react-icons/bi';
import { BsClipboardData } from 'react-icons/bs';
import { FaUsers } from "react-icons/fa";
import { IoShirt } from "react-icons/io5";

const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const navItemss = [
  { to: '/Dashboard', id:1, name: 'Dashboard', exact: false, Icon: RiDashboardLine },
];


const navComponents = [
  {
    to: '/Buyeroderview',
    name: 'Buyer Order',
    exact: false,
    id:31,
    Icon: MdShoppingCartCheckout,
  },
  {
    to: '/Workorderview',
    name: 'Work Order',
    exact: false,
    id:32,
    Icon: MdOutlineShoppingBag,
  },
  {
    to: '/assignOrderForInspection',
    name: 'Order Assign',
    exact: false,
    id: 40,
    Icon: BiMessageSquareEdit,
  },
  // {
  //   to: '/inspection',
  //   name: 'Create Inspection',
  //   exact: false,
  //   id:33,
  //   Icon: PiCheckSquareOffsetFill,
  // },
  {
    to: '/inspectionModify',
    name: 'Inspection',
    exact: false,
    id:34,
    Icon: BiMessageSquareEdit,
  },
  {
    to: '/Transactionimport',
    name: 'Transaction Import',
    exact: false,

    Icon: VscOpenPreview,
  },
];

const Reports = [
  {
    to: '/BookedorderReport',
    name: 'Booked order',
    exact: false,
    id:36,
    Icon: VscOpenPreview,
  },
  {
    to: '/inspectionsummary',
    name: 'Defects Summary',
    exact: false,
    id:37,
    Icon: VscOpenPreview,
  },

  {
    to: '/inspectionReport',
    name: 'Inspection Report',
    exact: false,
    id:38,
    Icon: BsUiChecks,
  },
  {
    to: '/Factoryordersheet',
    name: 'Factory Order Sheet',
    exact: false,
    id:39,
    Icon: BiSpreadsheet,
  },
  {
    to: '/AssignorderReport',
    name: 'Assign Order Report',
    exact: false,
    id:"Y",
    Icon: BiMessageSquareEdit,
  },
];

const Logoutt = [
  { to: '/logout', name: 'log out', exact: false, Icon: MdExitToApp },
];

const Users = [
 
  {
    to: '/Department',
    name: 'Department',
    exact: false,
    id:5,
    Icon: MdOutlineAddBusiness,
  },
  {
    to: '/Designation',
    name: 'Designation',
    exact: false,
    id:6,
    Icon: MdOutlineAddBusiness,
  },

  { to: '/user', id:7, name: 'User', exact: false, Icon: FaUserCog },
  { to: '/AuditMst', id:9, name: 'Audit', exact: false, Icon: AiOutlineAudit },
  { to: '/userrole', id:8, name: 'User Role', exact: false, Icon: AiOutlineAudit },
]
const ledgers = [
  { to: '/Buyer', id:11, name: 'Buyer', exact: false, Icon: MdOutlineAddBusiness },
  {
    to: '/Supplier',
    name: 'Supplier',
    id:12,
    exact: false,
    Icon: MdAddBusiness,
  },
  { to: '/companylog',id:13, name: 'Company log', exact: false, Icon: HomeWorkIcon },
]

const garments =[
  { to: '/Garment', id:15,name: 'Garment', exact: false, Icon: GiClothes },
  { to: '/Color',id:16, name: 'Color', exact: false, Icon: IoColorPaletteOutline },
  { to: '/UOM',id:17 ,name: 'UOM', exact: false, Icon: AiOutlineDeploymentUnit },
  { to: '/Fabric',id:18, name: 'Fabric', exact: false, Icon: GiRolledCloth },
  {
    to: '/defactcategory',
    name: ' Defect Category',
    exact: false,
    id:19,
    Icon: VscGroupByRefType,
  },
  {
    to: '/Subcategory',
    name: 'Sub category',
    exact: false,
    id:20,
    Icon: VscTypeHierarchySub,
  },
  {
    to: '/Qaparameter',
    name: 'Qa Parameter',
    exact: false,
    id:21,
    Icon: MdOutlineSettingsInputComposite,
  },
]
const othersvalue=[
  {
    to: '/Division',
    name: 'Division',
    id:23,
    exact: false,
    Icon: PiOfficeChairLight,
  },
  { to: '/country',id:24, name: 'Country', exact: false, Icon: TbWorldPlus },
  {
    to: '/Currency',
    name: 'Currency',
    id:25,
    exact: false,
    Icon: RiMoneyDollarCircleLine,
  },
  { to: '/Season',id:26, name: 'Season', exact: false, Icon: SiCodeclimate },
  {
    to: '/BuyerGroup',
    name: 'Buyer Group',
    exact: false,
    id:27,
    Icon: TiGroupOutline,
  },
  {
    to: '/BuyersizeRange',
    name: 'Buyer size Range',
    exact: false,
    id:28,
    Icon: TbRulerMeasure,
  },
  {
    to: '/Buyersizedetail',
    name: 'Buyer size detail',
    exact: false,
    id:28,
    Icon: StraightenIcon,
  },
  { to: '/POM',id:29, name: 'POM', exact: false, Icon: MdOutlineLinearScale },
  
]



const navItems = [
  // Masters

  { to: '/Company',id:3, name: 'Company', exact: false, Icon: HomeWorkIcon },


  
  
];

const bem = bn.create('sidebar');

const Sidebar = () => {
  const [isOpenComponents, setIsOpenComponents] = useState(false);
  const [isOpenTransactiosn, setIsOpenTransactiosn] = useState(false);
  const [isOpenReports, setIsOpenReports] = useState(false);
  const [useropencomponents, setuseropencomponents] = useState(false);
const [ledgeropen, setledgeropen] = useState(false)
const [garmentpoppup, setgarmentpoppup] = useState(false)
const [otherspopup, setotherspopup] = useState(false)
  const handleClick = name => () => {
    setIsOpenComponents(prevState => !prevState);
  };

  const handleClicktrans = name => () => {
    setIsOpenTransactiosn(prevState => !prevState);
  };

  const handleClickReports = name => () => {
    setIsOpenReports(prevState => !prevState);
  };
  const handleClickuseropen = name => () => {
    setuseropencomponents(prevState => !prevState);
  };
  const handleClickuledgeropen = name => () => {
    setledgeropen(prevState => !prevState);
  };
  const handlegarmentpopup = name => () => {
    setgarmentpoppup(prevState => !prevState);
  };
  const handleotherpopup = name => () => {
    setotherspopup(prevState => !prevState);
  };

  const handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    // document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  return (
    <aside className={bem.b()} data-image={sidebarBgImage}>
      <div className={bem.e('background')} style={sidebarBackground} />

        <div className={bem.e('content')}>
          <div className=" pt-4 d-flex justify-content-center align-items-center ">
            <div
              className="bg-white mx-4 p-0 card"
              style={{
                boxShadow:
                  'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
              }}
            >
              <img src={logoqa} style={{ objectFit: 'contain' }} alt="logoqa" />
            </div>
          </div>
          <Navbar>
            <span className="text-white"></span>
          </Navbar>
          {
            <Nav vertical>
              {navItemss.filter(c=> c.id === parseInt(localStorage.getItem('Dashboard')))
              
              
              .map(({ to, name, exact, Icon }, index) => (
                <NavItem
                  key={index}
                  className={bem.e('nav-item')}
                  onClick={handleSidebarControlButton}
                >
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
{parseInt(localStorage.getItem('Master')) == 2 ?(

<div>
              <NavItem
                className={bem.e('nav-item')}
                onClick={handleClick('Components')}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex d-flex justify-content-center align-items-center">
                    {/* <MdExtension className={bem.e('nav-item-icon')} /> */}
                    <QueuePlayNextIcon className={bem.e('nav-item-icon')} />
                    <span className="  ">Masters</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: isOpenComponents
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>

              <Collapse isOpen={isOpenComponents}>
                {navItems.filter(c => c.id === parseInt(localStorage.getItem("Company")) 
                  
                    )
                
                .map(({ to, name, exact, Icon }, index) => (
                  <NavItem
                    key={index}
                    className={bem.e('nav-item ml-3')}
                    onClick={handleSidebarControlButton}
                  >
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className="ml-3  "
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="small">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}


{/* users */}
{parseInt(localStorage.getItem('Users')) === 4 ? (  
                <div className="m-2">
                  <NavItem
                    className={bem.e('nav-item')}
                    onClick={handleClickuseropen('Components')}
                  >
                    <BSNavLink className={bem.e('nav-item-collapse  mx-2')}>
                      <div className="d-flex d-flex justify-content-center align-items-center">
                        <FaUserCog className={bem.e('nav-item-icon')} />
                        <span>Users</span>
                      </div>
                      <MdKeyboardArrowDown
                        className={bem.e('nav-item-icon')}
                        style={{
                          padding: 0,
                          transform: useropencomponents
                            ? 'rotate(0deg)'
                            : 'rotate(-90deg)',
                          transitionDuration: '0.3s',
                          transitionProperty: 'transform',
                        }}
                      />
                    </BSNavLink>
                  </NavItem>

                  <Collapse isOpen={useropencomponents}>
                    {Users.filter(c => c.id === parseInt(localStorage.getItem("Department")) || c.id === parseInt(localStorage.getItem("Designation")) 
                    || c.id === parseInt(localStorage.getItem("UserList"))
                    || c.id === parseInt(localStorage.getItem("Audit"))
                    || c.id === parseInt(localStorage.getItem("UserRole"))
                    )
                    
                    .map(({ to, name, exact, Icon }, index) => (
                      <NavItem
                        key={index}
                        className={bem.e('nav-item ml-3')}
                        onClick={handleSidebarControlButton}
                      >
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className=" ml-3"
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e('nav-item-icon')} />
                          <span className="small">{name}</span>
                        </BSNavLink>
                      </NavItem>
                    ))}
                  </Collapse>
                </div>
):null}
{/* ledger */}
{parseInt(localStorage.getItem('Ledger')) === 10 ? (
<div className="m-2">

  <NavItem
  className={bem.e('nav-item')}
  onClick={handleClickuledgeropen('Components')}
>
  <BSNavLink className={bem.e('nav-item-collapse  mx-2')}>
    <div className="d-flex d-flex justify-content-center align-items-center">
      <FaUsers  className={bem.e('nav-item-icon')} />
      <span>Ledger</span>
    </div>
    <MdKeyboardArrowDown
      className={bem.e('nav-item-icon')}
      style={{
        padding: 0,
        transform: ledgeropen
          ? 'rotate(0deg)'
          : 'rotate(-90deg)',
        transitionDuration: '0.3s',
        transitionProperty: 'transform',
      }}
    />
  </BSNavLink>
</NavItem>
 
                  

                  <Collapse isOpen={ledgeropen}>
                    {ledgers.filter(c => c.id === parseInt(localStorage.getItem("Supplier")) || c.id === parseInt(localStorage.getItem("Buyer")) 
                    || c.id === parseInt(localStorage.getItem("Company log")))
                    
                    .map(({ to, name, exact, Icon }, index) => (
                      <NavItem
                        key={index}
                        className={bem.e('nav-item ml-3')}
                        onClick={handleSidebarControlButton}
                      >
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className=" ml-3"
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e('nav-item-icon')} />
                          <span className="small">{name}</span>
                        </BSNavLink>
                      </NavItem>
                    ))}
                  </Collapse>
                </div>
):null}
                {/* garment */}
                {parseInt(localStorage.getItem('Garment')) === 14 ? (
                <div className="m-2">
                  <NavItem
                    className={bem.e('nav-item')}
                    onClick={handlegarmentpopup('Components')}
                  >
                    <BSNavLink className={bem.e('nav-item-collapse  mx-2')}>
                      <div className="d-flex d-flex justify-content-center align-items-center">
                        <IoShirt  className={bem.e('nav-item-icon')} />
                        <span>Garment</span>
                      </div>
                      <MdKeyboardArrowDown
                        className={bem.e('nav-item-icon')}
                        style={{
                          padding: 0,
                          transform: garmentpoppup
                            ? 'rotate(0deg)'
                            : 'rotate(-90deg)',
                          transitionDuration: '0.3s',
                          transitionProperty: 'transform',
                        }}
                      />
                    </BSNavLink>
                  </NavItem>

                  <Collapse isOpen={garmentpoppup}>
                    {garments.filter(c => c.id === parseInt(localStorage.getItem("GarmentDescription")) ||
                    
                    c.id === parseInt(localStorage.getItem("UOM")) ||
                    c.id === parseInt(localStorage.getItem("Color")) 
                    || c.id === parseInt(localStorage.getItem("FabricComposition"))
                    || c.id === parseInt(localStorage.getItem("DefectCategory"))
                    || c.id === parseInt(localStorage.getItem("DefectCategoryDescription"))
                    || c.id === parseInt(localStorage.getItem("AQLParameter"))
                    ) 
                    .map(({ to, name, exact, Icon }, index) => (
                      <NavItem
                        key={index}
                        className={bem.e('nav-item ml-3')}
                        onClick={handleSidebarControlButton}
                      >
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className=" ml-3"
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e('nav-item-icon')} />
                          <span className="small">{name}</span>
                        </BSNavLink>
                      </NavItem>
                    ))}
                  </Collapse>
                </div>
                ):null}
{/* {others} */}
{parseInt(localStorage.getItem('Other')) === 22 ? (
                <div className="m-2">
                  <NavItem
                    className={bem.e('nav-item')}
                    onClick={handleotherpopup('Components')}
                  >
                    <BSNavLink className={bem.e('nav-item-collapse  mx-2')}>
                      <div className="d-flex d-flex justify-content-center align-items-center">
                        <FaUserCog  className={bem.e('nav-item-icon')} />
                        <span>Other</span>
                      </div>
                      <MdKeyboardArrowDown
                        className={bem.e('nav-item-icon')}
                        style={{
                          padding: 0,
                          transform: otherspopup
                            ? 'rotate(0deg)'
                            : 'rotate(-90deg)',
                          transitionDuration: '0.3s',
                          transitionProperty: 'transform',
                        }}
                      />
                    </BSNavLink>
                  </NavItem>

                  <Collapse isOpen={otherspopup}>
                    {othersvalue.filter(c => c.id === parseInt(localStorage.getItem("Division")) || c.id === parseInt(localStorage.getItem("Country")) 
                    || c.id === parseInt(localStorage.getItem("Currency"))
                    || c.id === parseInt(localStorage.getItem("Season"))
                    || c.id === parseInt(localStorage.getItem("Buyer Group"))
                    || c.id === parseInt(localStorage.getItem("Buyer size Range"))
                    || c.id === parseInt(localStorage.getItem("POM"))
                    ) 
                    
                    
                    .map(({ to, name, exact, Icon }, index) => (
                      <NavItem
                        key={index}
                        className={bem.e('nav-item ml-3')}
                        onClick={handleSidebarControlButton}
                      >
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className=" ml-3"
                          tag={NavLink}
                          to={to}
                          activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e('nav-item-icon')} />
                          <span className="small">{name}</span>
                        </BSNavLink>
                      </NavItem>
                    ))}
                  </Collapse>
                </div>
):null}
              </Collapse>
</div>
):null}


              {parseInt(localStorage.getItem('Merchandising')) === 30 ? (            
<div>
              <NavItem
                className={bem.e('nav-item')}
                onClick={handleClicktrans('Components')}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex d-flex justify-content-center align-items-center">
                    <BiTransferAlt className={bem.e('nav-item-icon')} />
                    <span className="  ">Transactions</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: isOpenTransactiosn
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>

              <Collapse isOpen={isOpenTransactiosn}>
                {navComponents.filter(c => c.id === parseInt(localStorage.getItem("BuyerOrder")) || c.id === parseInt(localStorage.getItem("WorkOrder")) 
                    || c.id === parseInt(localStorage.getItem("Inspection"))
                    || c.id === parseInt(localStorage.getItem("InspectionList"))
                  
                    || c.id === parseInt(localStorage.getItem("OrderAssign"))
          
                
                    ) 
                .map(({ to, name, exact, Icon }, index) => (
                  <NavItem
                    key={index}
                    className={bem.e('nav-item ml-3')}
                    onClick={handleSidebarControlButton}
                  >
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className=" ml-3"
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="small">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
              </div>
              ):null}

  {parseInt(localStorage.getItem('MIS')) === 35 ? (    
              <div>
              <NavItem
                className={bem.e('nav-item')}
                onClick={handleClickReports('Components')}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex d-flex justify-content-center align-items-center">
                    <BsClipboardData className={bem.e('nav-item-icon')} />
                    <span>Reports</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: isOpenReports
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>

              <Collapse isOpen={isOpenReports}>
                {Reports.filter(c => c.id === parseInt(localStorage.getItem("BookedOrder")) || c.id === parseInt(localStorage.getItem("inspectionSummary")) 
                    || c.id === parseInt(localStorage.getItem("InspectionReport"))
                    || c.id === parseInt(localStorage.getItem("FactoryOrderSheet"))
                  
                    || c.id === (localStorage.getItem("Assignee"))                ).
                
                
                map(({ to, name, exact, Icon }, index) => (
                  <NavItem
                    key={index}
                    className={bem.e('nav-item ml-3')}
                    onClick={handleSidebarControlButton}
                  >
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className=" ml-3"
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="small">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
              </div>
  ):null}
              {/* {Logoutt.map(({ to, name, exact, Icon }, index) => (
                <NavItem
                  key={index}
                  className={bem.e('nav-item ')}
                  onClick={handleSidebarControlButton}
                >
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))} */}
            </Nav>
          }
        </div>
      ) : (
        <div className={bem.e('content')}>
          <Navbar>
            <span className="text-white">
              <img src={logoqa} height="120px" width="230px" alt="ssss" />
            </span>
          </Navbar>
          {
            <Nav vertical>
              {navItemss.map(({ to, name, exact, Icon }, index) => (
                <NavItem
                  key={index}
                  className={bem.e('nav-item')}
                  onClick={handleSidebarControlButton}
                >
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            
                <NavItem
                  className={bem.e('nav-item')}
                  onClick={handleClick('Components')}
                >
                  <BSNavLink className={bem.e('nav-item-collapse')}>
                    <div className="d-flex">
                      <MdExtension className={bem.e('nav-item-icon')} />
                      <span className=" align-self-start">Master</span>
                    </div>
                    <MdKeyboardArrowDown
                      className={bem.e('nav-item-icon')}
                      style={{
                        padding: 0,
                        transform: isOpenComponents
                          ? 'rotate(0deg)'
                          : 'rotate(-90deg)',
                        transitionDuration: '0.3s',
                        transitionProperty: 'transform',
                      }}
                    />
                  </BSNavLink>
                </NavItem>
         
            
                <Collapse isOpen={isOpenComponents}>
                  {navItems.map(({ to, name, exact, Icon }, index) => (
                    <NavItem
                      key={index}
                      className={bem.e('nav-item ml-3')}
                      onClick={handleSidebarControlButton}
                    >
                      <BSNavLink
                        id={`navItem-${name}-${index}`}
                        className=" ml-3"
                        tag={NavLink}
                        to={to}
                        activeClassName="active"
                        exact={exact}
                      >
                        <Icon className={bem.e('nav-item-icon')} />
                        <span className="small">{name}</span>
                      </BSNavLink>
                    </NavItem>
                  ))}
                </Collapse>
           

              {navComponents.map(({ to, name, exact, Icon }, index) => (
                <NavItem
                  key={index}
                  className={bem.e('nav-item')}
                  onClick={handleSidebarControlButton}
                >
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="small">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Nav>
          }
        </div>
   
    </aside>
  );
};

export default Sidebar;
